import { useGameContainer } from '../index';
import LocalizedDate from 'components/LocalizedDate';
import GoFanButton from '@/components/affiliates/GoFanButton';
import CalloutModule from '@/components/modules/CalloutModule';
import GoFanPoweredBy from '@/components/affiliates/GoFanPoweredBy';
import { ContestExpectedStatusEnum } from 'queries';

export default function GameFindTickets() {
  const [{ game }] = useGameContainer();

  if (!game.contest?.gofanTicketingUrl || game.contest.expectedStatus === ContestExpectedStatusEnum.COMPLETED) return null;

  return (
    <CalloutModule
      title="Find Tickets"
      right={<GoFanPoweredBy />}
      topText={<LocalizedDate date={game.date} format="ddd, MMMM D" />}
      entity={game.gameTeams.map(({ team }) => team)}
      footer={<GoFanButton href={game.contest.gofanTicketingUrl} />}
    />
  );
}
